"use strict";
import art from "./Art.js";
import CustomWebSocket from './CustomWebSocket.js'
//##############################################################################
//##############################################################################
// Protocol协议实现：消息头 + 消息元数据 + 消息。
var protocol = {};

// protocol category.
protocol.category_message   = 0x01;
protocol.category_heartbeat = 0x02;
protocol.category_authority = 0x04;
protocol.category_checksum  = 0x08;
protocol.category_encrypted = 0x10;
protocol.category_sync_mode = 0x20;
// protocol model.
protocol.model_topic_type   = 0x01;
protocol.model_topic_prop   = 0x02;
protocol.model_topic_value  = 0x04;
protocol.model_topic_str    = 0x08;
// protocol option.
protocol.option_last        = 0x01;
protocol.option_type        = 0x02;
protocol.option_req4        = 0x04;
protocol.option_req8        = 0x08;
protocol.option_req1        = 0x10;
protocol.option_req2        = 0x20;
// protocol member size.
protocol.size_version       = 1;
protocol.size_category      = 1;
protocol.size_model         = 1;
protocol.size_option        = 1;
protocol.size_type          = 2;
protocol.size_req1          = 1;
protocol.size_req2          = 2;
protocol.size_req4          = 4;
protocol.size_req8          = 8;


////////////////////////////////////////////////////////////////////////////////
// 消息元数据构造函数
function MessageMeta() {
    this.m_category = protocol.category_message;
    this.m_model = 0;
    this.m_option = 0;
    this.m_type = 0;
    this.m_request_data = 0;
}
// 设置32位请求ID
MessageMeta.prototype.setReq4 = function (value) {
    this.m_option |= protocol.option_req4;
    this.m_request_data = value;
}
// 设置32位请求ID
MessageMeta.prototype.last = function () {
    return art.hasValue(this.m_option, protocol.option_last);
}


////////////////////////////////////////////////////////////////////////////////
// 获取元数据大小
protocol.getMetaSize = function (meta) {
    var size = protocol.size_version;
    size += protocol.size_category;
    size += protocol.size_model;
    size += protocol.size_option;
    if (art.hasValue(meta.m_option, protocol.option_type)) {
        size += protocol.size_type;
    }
    if (art.hasValue(meta.m_option, protocol.option_req1))
        size += protocol.size_req1;
    if (art.hasValue(meta.m_option, protocol.option_req2))
        size += protocol.size_req2;
    if (art.hasValue(meta.m_option, protocol.option_req4))
        size += protocol.size_req4;
    if (art.hasValue(meta.m_option, protocol.option_req8))
        size += protocol.size_req8;
    return size;
}
// 获取协议版本信息
protocol.getVersion = function () {
    return 1;
}


////////////////////////////////////////////////////////////////////////////////
// 将Protobuf消息序列化为字节数组
protocol.encode = function (msg, meta) {
    if (!(msg instanceof Object)) {
        console.error("message is not a protobuf.");
        return;
    }
    var msg_bytes = msg.serializeBinary();
    var byte_size = protocol.getMetaSize(meta);
    byte_size += msg_bytes.byteLength;
    var bytes = new ArrayBuffer(byte_size);

    // write message meta to bytes array.
    var pos = 0;
    pos = art.setBytes(bytes, pos, 1, protocol.getVersion());
    pos = art.setBytes(bytes, pos, 1, meta.m_category);
    pos = art.setBytes(bytes, pos, 1, meta.m_model);
    pos = art.setBytes(bytes, pos, 1, meta.m_option);
    if (art.hasValue(meta.m_option, protocol.option_type)) {
        pos = art.setBytes(bytes, pos, 2, meta.m_type);
    }
    if (art.hasValue(meta.m_option, protocol.option_req1))
        pos = art.setBytes(bytes, pos, 1, meta.m_request_data);
    if (art.hasValue(meta.m_option, protocol.option_req2))
        pos = art.setBytes(bytes, pos, 2, meta.m_request_data);
    if (art.hasValue(meta.m_option, protocol.option_req4))
        pos = art.setBytes(bytes, pos, 4, meta.m_request_data);
    if (art.hasValue(meta.m_option, protocol.option_req8))
        pos = art.setBytes(bytes, pos, 8, meta.m_request_data);

    // write message bytes to bytes array.
    pos = art.copyBytes(bytes, pos, msg_bytes);
    return bytes;
}


////////////////////////////////////////////////////////////////////////////////
// 将字节数组解析为Protobuf消息
protocol.decode = function (meta, buff) {
    var view = new DataView(buff);

    // parse message meta.
    var pos = 1;    // version.
    meta.m_category = view.getUint8(pos++);
    meta.m_model = view.getUint8(pos++);
    meta.m_option = view.getUint8(pos++);
    if (art.hasValue(meta.m_option, protocol.option_type)) {
        meta.m_type = view.getUint16(pos);
        pos += 2;
    }
    if (art.hasValue(meta.m_option, protocol.option_req1)) {
        meta.m_request_data = view.getUint8(pos++);
    } else if (art.hasValue(meta.m_option, protocol.option_req2)) {
        meta.m_request_data = view.getUint16(pos);
        pos += 2;
    } else if (art.hasValue(meta.m_option, protocol.option_req4)) {
        meta.m_request_data = view.getUint32(pos);
        pos += 4;
    } else if (art.hasValue(meta.m_option, protocol.option_req8)) {
        meta.m_request_data = view.getFloat64(pos);
        pos += 8;
    }
    // parse message object.
    return pos;
}



//##############################################################################
//##############################################################################
// 基于WebSocket的协议构造函数，详见eco.WebSocketProtocol。
export default function WebSocketProtocol() {
    this.address = "";                  // 未带端口的IP地址
    this.addressCur = -1;               // 当前地址
    this.addressEnd = -1;             // 开始地址
    this.addressSet = null;             // 服务器地址集合
    this.requestId = 0;                 // 请求ID
    this.requestMap = {};               // 请求ID与回调函数
    this.publishMap = {};               // 发布ID与回调函数

    this.socket = null;                 // 网络连接WebSocket
    // 网络关闭状态，保证自动断开只调用一次。连接成功后，才=true。
    this.firstClose = false;
    // 异常断开将自动重连，而主动断开必须主动连接。
    this.flow = new art.Flow(1500);     // 流量控制
    this.flow.start();
    this.autoMount = null;              // 自动加载/主动断开（见activeClose）
    this.mounted = false;               // 自动恢复页面成功
}
WebSocketProtocol.e_timeout     = -3;   // 网络超时
WebSocketProtocol.e_send_fail   = -4;   // 发送失败
WebSocketProtocol.e_network     = -5;   // 连接失败

////////////////////////////////////////////////////////////////////////////////
// 设置网络地址
WebSocketProtocol.prototype.setAddress = function (address, addressSet) {
    if (this.address != address) {
        this.address = address;
        this.addressSet = addressSet;
        return true;
    }
    return false;
}


////////////////////////////////////////////////////////////////////////////////
WebSocketProtocol.prototype.onClear = function () { }
// 通知事件：自动重连数据恢复成功
WebSocketProtocol.prototype.onOpen = function () { }
// 通知事件：网络异常断开(active=false)；网络手动关闭(active=true)
WebSocketProtocol.prototype.onClose = function (active) { }
WebSocketProtocol.prototype.setEvent = function (onOpen, onClose, onClear) {
    this.onOpen = onOpen;
    this.onClose = onClose;
    this.onClear = onClear;
}


////////////////////////////////////////////////////////////////////////////////
// 手动关闭网络连接
WebSocketProtocol.prototype.close = function () {
    this.activeClose(true);
    this.onClear();     // 清理数据
    if (this.socket != null) {
        this.socket.close();
        this.socket = null;
        this.onClose(true);
        this.firstClose = false;
    }
}
// 关键数据查询出错，关闭网络等待重连。
WebSocketProtocol.prototype.reopen = function () {
    this.onClear();     // 清理数据
    if (this.socket != null) {
        this.socket.close();
    }
}


////////////////////////////////////////////////////////////////////////////////
/* 设置手动关闭模式；返回当前是否为手动关闭。
autoMount状态值如下：
1.null-主动断开(默认)，同时主动断开表示不自动重连。
2.undefined-非主动断开
3.function-自动重连函数
*/
WebSocketProtocol.prototype.getActiveClose = function () {
    return this.autoMount == null;  // 返回手动关闭状态
}
WebSocketProtocol.prototype.activeClose = function (active) {
    // 设置手动关闭状态
    if (active) {
        this.autoMount = null;
        return;
    }

    // 设置非主动断开
    if (this.autoMount == null) {
        this.autoMount = undefined;
    }
    // 自动重连函数
    //else if (this.autoMount instanceof Function) {}
}


////////////////////////////////////////////////////////////////////////////////
WebSocketProtocol.prototype.mountInit = function (pageMount, login, ready) {
    var that = this;
    that.autoMount = function () {
        if (that.mounted) return;   // 正在恢复数据
        that.mounted = true;

        // #.自动恢复页面数据失败，继续恢复
        var reject = function () {
            that.mounted = false;
            that.resume();
        };

        // 2.加载页面数据：成功-通知自动重连成功；失败-继续恢复。
        var mount = function () {
            pageMount(reject);
            if (that.mounted) that.onOpen();
        };

        // 1.登录系统并初始化
        if (!ready()) {
            login(mount, reject);
            return;
        }
        mount();
    };
}


////////////////////////////////////////////////////////////////////////////////
// 程序异常断开时，自动恢复当前页面数据。
WebSocketProtocol.prototype.mount = function (pageMount, login, ready) {
    if (!(pageMount instanceof Function)) return;
    /*
    #.自动恢复页面数据过程：
    1.登录系统与初始化全局数据。(login -> ready)
    2.恢复当前页面数据。（pageMount -> this.mounted）
    注意：为保证能成功地自动恢复页面数据，并允许每个过程失败，则需跟踪每个过程的状态。
    如：login->ready登录初始化的状态，pageMount->mounted页面数据恢复状态。
    */
    this.mountInit(pageMount, login, ready);

    // 客户端调用mount方法时，将加载一次“页面数据”
    pageMount();
}


////////////////////////////////////////////////////////////////////////////////
WebSocketProtocol.prototype.resume = function () {
    var that = this;

    // 1.网络自动连接后恢复页面数据，需要接口提供获取数据的autoMount方法。
    // 2.主动断开：会将that.autoMount置空。
    if (!(that.autoMount instanceof Function)) {
        return;
    }

    // 已连接则直接恢复数据；未连接则定时恢复数据（3秒）
    if (that.opened()) {
        that.autoMount();
    } else {
        setTimeout(() => that.run("autoMount", that.autoMount), 3000);
    }
}


////////////////////////////////////////////////////////////////////////////////
WebSocketProtocol.prototype.run = function (name, work, reject) {
    var that = this;
    // 1.Socket未创建，则创建Socket；
    if (!that.opened()) that.init(true);

    // 2.Socket连接成功，则调用方法。
    var waitWork = function (times) {
        if (that.opened()) {
            work();
            return;
        }
        // 3.等待Socket连接成功。
        if (times < 100) {   // 等待10秒
            setTimeout(() => waitWork(++times), 100);
            return;
        }
        // 4.网络连接超时
        console.error("网络连接超时：" + name);
        if (reject instanceof Function) {
            var msg = "网络连接超时，请检查网络是否打开。";
            reject({ id: WebSocketProtocol.e_network, message: msg });
        }
    };
    waitWork(0);
}


////////////////////////////////////////////////////////////////////////////////
// 连接网络
WebSocketProtocol.prototype.init = function (restart) {
    var that = this;
    if (that.socket) return;    // 正在连接

    // -------------------------------------------------------------------------
    /* #.负载均衡算法
    1.第一次连接服务器，在地址集合随机选择。
    2.服务器断开后连接服务器，则进行轮训。
    */
    if (restart) {
        that.addressCur = art.random(0, that.addressSet.length - 1);
        that.addressEnd = (that.addressCur - 1 + that.addressSet.length) % that.addressSet.length;
    } else {
        that.addressCur = ++that.addressCur % that.addressSet.length;
    }
    var address = that.addressSet[that.addressCur];

    // 连接服务器地址，设置超时。
    if(process.env.NODE_ENV === 'development')
      console.log("connect: " + address);
    that.socket = new CustomWebSocket(address);
    var socketTimeout = that.socket;
    setTimeout(function() {
        if (socketTimeout.readyState != CustomWebSocket.OPEN) {
            socketTimeout.close();
        }
    }, 3000);

    // -------------------------------------------------------------------------
    /* #.自动重连方案
    1.断开事件监控：网络正常关闭onclose；网络异常关闭onerror；系统网络设置监控（TODO）
    2.网络连接不上有可能是因为用户未设置Wifi与移动网络导致，应监控网络连接设置，成功后
    马上自动重连。
    3.若异常断开（如网络异常断开或者服务器宕机），则轮询连接下个服务器地址。
    4.服务器连接成功后，调用autoMount恢复当前页面的数据。
    */
    that.socket.onopen = (evt) => {
      if(process.env.NODE_ENV === 'development')
          console.log("websocket open");
        that.firstClose = true;
        that.activeClose(false);
        that.resume();
    };
    that.socket.onclose = (evt) => {
        if(process.env.NODE_ENV === 'development')
          console.log("websocket close(" + evt.code + ")");
        this.onClear();     // 清理数据

        // 异常断开只通知第一次，自动重连的断开将不再通知。
        if (that.socket) {
            that.socket = null;
            that.mounted = false;
            if (that.firstClose) {
                that.onClose(that.getActiveClose());
                that.firstClose = false;
            }

            if (that.addressCur != that.addressEnd) {
                // 若连接失败，则继续连接下一个。
                    that.init(false);
            } else {
                // 所有连接都已尝试，则等待一段时间再重连
                that.resume();
            }
        }
    };
    // 3.连接服务器错误
    that.socket.onerror = (evt) => {};

    // -------------------------------------------------------------------------
    /* #.接收服务回报消息
    1.请求回报：给请求设定唯一标识发送到服务端，服务端发送回报会携带该标识。
    2.订阅发布：注册该发布消息的回调函数。
    */
    that.socket.onmessage = (evt) => {
        if (!evt.data instanceof Blob) {
            console.error("websocket message is not blob.");
            return;
        }

        // 读取二进制数据
        var reader = new FileReader();
        reader.readAsArrayBuffer(evt.data);
        reader.onloadend = (evt) => {
            if(process.env.NODE_ENV === 'development')
              console.log("onmessage");
            // 解析元数据与消息体
            var buff = evt.target.result;
            var meta = new MessageMeta();
            var start = protocol.decode(meta, buff);
            var bytes = new Uint8Array(buff, start);
            // 1.订阅/发布-根据消息ID调用回报方法
            var onPub = that.publishMap[meta.m_type];
            if (onPub) {
                onPub(bytes, meta.m_request_data);
                return;
            }
            // 2.请求/回报-根据ReqId获取回报方法
            var onRsp = that.requestMap[meta.m_request_data];
            if (onRsp !== undefined) {
                onRsp(bytes, meta.last());  // 清除异步请求
                if (meta.last()) delete that.requestMap[meta.m_request_data];
            }
        }
    } // onmessage
}
// 连接网络成功
WebSocketProtocol.prototype.opened = function () {
    return this.socket && this.socket.readyState == CustomWebSocket.OPEN;
}


////////////////////////////////////////////////////////////////////////////////
// 注册发布消息与对应的回调函数
WebSocketProtocol.prototype.subscribe = function (msgType, Type, onPub) {
    this.publishMap[msgType] = function (bytes, last) {
        var pub = Type.deserializeBinary(bytes).toObject();
        var remove = (pub.stamp == art.meta.stamp_remove);
        onPub(pub, last, remove);
    };
}
// 取消注册发布消息与对应的回调函数
WebSocketProtocol.prototype.unsubscribe = function (msgType) {
    this.publishMap[msgType] = undefined;
}


////////////////////////////////////////////////////////////////////////////////
WebSocketProtocol.prototype.send = function (req, Rsp, option) {
    var that = this;
    // #1.回调函数定义。
    var onReject = function (error) {
        if (option && option.reject instanceof Function)
            option.reject(error);
    };
    var onResolve = function (data, last) {
        if (option && option.resolve instanceof Function)
            option.resolve(data, last);
    };
    var work = function () {
        try {
            // #2.填写请求ID/元数据
            if (++that.requestId == 0)++that.requestId;
            var req_id = that.requestId;
            var meta = new MessageMeta();
            meta.m_type = req.reqType;
            meta.m_option = protocol.option_type;
            meta.setReq4(req_id);

            // #3.接口超时处理
            var timeout = 13000;
            var timeoutClose = false;
            if (option && option.timeout !== undefined)
                timeout = option.timeout;
            if (option && option.timeoutClose) {
                timeoutClose = true;
            }
            if (timeout != 0) {     // timeout==0，则不处理超时
                var timer = setTimeout(function () {
                    delete that.requestMap[req_id];
                    // 关键数据无回报则断开连接。
                    if (timeoutClose) {
                        that.reopen();
                    }
                    onReject({
                        id: WebSocketProtocol.e_timeout,
                        message: "请求服务数据超时。"
                    });
                    console.error("timeout " + meta.m_type);
                }, timeout);
            }

            // #4.接口回报处理
            // 发送消息前，缓存请求ID，便于接收消息时调用回报。
            that.requestMap[req_id] = function (bytes, last) {
                if (timer !== undefined) clearTimeout(timer);
                // 1.错误回报
                var rsp = Rsp.deserializeBinary(bytes);
                if (rsp.hasError()) {
                    onReject(rsp.getError().toObject());
                }
                // 2.正确数据回报：单个
                else if (rsp.getData !== undefined) {
                    if (rsp.hasData())
                        var data = rsp.getData().toObject();
                    onResolve(data, last);
                }
                // 3.正确数据回报：列表
                else if (rsp.getDataList !== undefined) {
                    onResolve(rsp.toObject().dataList);
                }
            };
            // #5.发送数据
            that.socket.send(protocol.encode(req, meta));
        } catch (e) {
            // #6.发送数据异常处理
            var msg = "发送消息错误(" + req.reqType + ")" + e.message;
            console.error(msg);
            onReject({ id: WebSocketProtocol.e_send_fail, message: msg });
        }
    };

    // #7.流量控制
    if (option && option.control) {
        var workFlow = function () {
            that.flow.run(work,
                option.control.taskName,
                option.control.discard,
                option.control.interval);
        }
        that.run(req.reqType, workFlow, onReject);
        return;
    }
    that.run(req.reqType, work, onReject);
}



// WEBPACK FOOTER //
// ./static/js/proto/art/WebSocketProtocol.js